// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2hGdC","label":"Labeled_label__1NHR4","divider":"Labeled_divider__3Kqa9"};